const translations = {
    applications: 'Applications',
    editFarm: 'Edit Farm',
    linkedEntities: 'Linked Entities'
};

export default translations;
